import React from 'react';

import { Button } from '../../components/Button/Button';
import { SiteNav } from '../../components/SiteNav/SiteNav';
import { useInView } from '../../hooks/useInView';
import type { CareersHero } from './types';

export function CareersHeroSection({ data }: { data: CareersHero }) {
    const [ref, inView] = useInView<HTMLDivElement>();

    return (
        <section className="careers-hero">
            <div
                ref={ref}
                className={`careers-hero__frame faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
            >
                <div className="careers-hero__bg">
                    {data.backgroundImage ? (
                        <img className="careers-hero__bg-img" src={data.backgroundImage} alt="" aria-hidden="true" />
                    ) : null}
                </div>
                <div className="careers-hero__nav">
                    <SiteNav />
                </div>
                <div className="careers-hero__content">
                    <div className="careers-hero__text">
                        <h1 className="careers-hero__heading faves-display faves-reveal">{data.heading}</h1>
                        <div
                            className="careers-hero__cta-wrap faves-reveal"
                            style={{ '--reveal-delay': '160ms' } as React.CSSProperties}
                        >
                            <Button label={data.cta.label} href={data.cta.href} variant="primary" />
                        </div>
                    </div>
                    <p
                        className="careers-hero__body faves-reveal"
                        style={{ '--reveal-delay': '240ms' } as React.CSSProperties}
                    >
                        {data.body}
                    </p>
                </div>
            </div>
        </section>
    );
}
